import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { LobBankAccount } from '../../../../models/entities/lob-bank-account';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lob-bank-account-selector',
  templateUrl: './lob-bank-account-selector.component.html',
    styleUrls: ['./lob-bank-account-selector.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LobBankAccountSelectorComponent implements OnInit, OnChanges {

    @Input() lobBankAccounts: LobBankAccount[] = [];
    @Input() allowNoBankSelection: boolean = true;
    @Input() formGroup: UntypedFormGroup;
    @Input() controlName: string = 'lobBankAccountId';
    @Input() placeholder: string = 'Select a bank account';
    @Output() bankAccountSelected: EventEmitter<LobBankAccount> = new EventEmitter<LobBankAccount>();

    constructor(
            private _fb: UntypedFormBuilder
    ) { }

    get accountItems(): { value: number; label: string }[] {
        return this.lobBankAccounts.map(account => ({
            value: account.id,
            label: `${account.description} - (${account.signatory})`,
        }));
    }

    ngOnInit(): void {
        if (!this.formGroup) {
            this.formGroup = this._fb.group({
                [this.controlName]: [null],
            });
        }

        // The parent supplies the list — an empty one means "no account may be selected", never
        // "no list given". This used to fall back to an unfiltered self-fetch, which put an
        // UNVERIFIED account on a scheduled check (SD-10055).
        this.autoSelectSingleAccount();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['lobBankAccounts'] && this.lobBankAccounts?.length > 0) {
            this.autoSelectSingleAccount();
        }
    }

    selectedBankChanged(accountId: number | null) {
        const selectedAccount = this.lobBankAccounts.find(account => account.id === accountId);
        this.bankAccountSelected.emit(selectedAccount);
    }

    private autoSelectSingleAccount(): void {
        // Auto-select if only one account exists (accounts are pre-filtered by parent component)
        if (this.lobBankAccounts.length === 1 && !this.formGroup.get(this.controlName)?.value) {
            const singleAccount = this.lobBankAccounts[0];
            this.formGroup.get(this.controlName)?.setValue(singleAccount.id);
            this.bankAccountSelected.emit(singleAccount);
        }
    }
}
